<template>
    <div class="train-box">
        <access-mag v-if="currentTab=='accessMag'"></access-mag>
        <video-monitor v-if="currentTab=='videoMonitor'"></video-monitor>
    </div>
</template>

<script>
import AccessMag from './intelligentTrain/AccessMag.vue';
import VideoMonitor from './intelligentTrain/VideoMonitor.vue';
    export default {
  components: { AccessMag, VideoMonitor },
        computed:{
            /**当前tab */
            currentTab(){
                    return this.$store.state.backend.currentTab;
                }
        },
    }
</script>

<style lang="less" scoped>
.train-box{
    height: 100%;
}
</style>